import React, { Component } from "react"
import styles from "../css/postlist.module.css"
import profileImg from "../../static/profile.webp"

export default class Bio extends Component {
  render() {
    return (
      <div className={styles.profile}>
        <img src={profileImg} alt="profile-picture" />
        <p>
          Personal Blog by&nbsp;
          <a id={styles.profilelink} href="https://twitter.com/NaimulIslamSiam">
            Naimul Islam Siam
          </a>
          .
          <br />
          Fascinated with JavaScript, CSS and the web.
        </p>
      </div>
    )
  }
}
